<template>
<!--  <nav>-->
<!--    <router-link to="/">Home</router-link> |-->
<!--    <router-link to="/about">About</router-link>-->
<!--  </nav>-->
  <router-view/>
</template>

<script>
import {getDictionaryList} from "@/api/system";

export default {
  data(){
    return{

    }
  },
  mounted() {
    getDictionaryList().then((res)=>{
      if(res.code ===1){
        localStorage.setItem('dictionaryList', JSON.stringify(res.data))
      }else {
        console.log('字典获取失败')
      }
    })
  }
}
</script>


<style>

</style>
